import { ReactNode } from 'react'

import MotionDiv from '@/components/common/Motion/MotionDiv'

interface SliderInputProps {
  label: string
  value: number
  min: number
  max: number
  step: number
  onChange: (value: number) => void
  note?: string
  suffix?: string
  icon?: ReactNode
}

export const SliderInput = ({ label, value, min, max, step, onChange, note, suffix = '€', icon }: SliderInputProps) => {
  return (
    <MotionDiv className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm text-zinc-700 flex items-center gap-2">
          {icon}
          {label}
        </label>
        <div className="flex items-center gap-1">
          <input
            type="number"
            value={value}
            onChange={(e) => {
              const v = Number(e.target.value)
              if (v >= min && v <= max) onChange(v)
            }}
            className="w-20 text-right px-2 py-1 rounded-lg border border-gray-200 text-sm text-zinc-700 outline-hidden focus:border-blue-600 focus:ring-2 focus:ring-blue-200"
          />
          <span className="text-sm text-zinc-500">{suffix}</span>
        </div>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-2 bg-zinc-100 rounded-full appearance-none cursor-pointer accent-blue-600
          [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:bg-blue-600 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:shadow-md
          [&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5 [&::-moz-range-thumb]:bg-blue-600 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:shadow-md"
      />
      <div className="flex justify-between mt-1">
        <span className="text-xs text-zinc-400">{min}{suffix}</span>
        <span className="text-xs text-zinc-400">{max}{suffix}</span>
      </div>
      {note && <p className="text-xs text-zinc-500 mt-1">{note}</p>}
    </MotionDiv>
  )
}

export default SliderInput
